import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { useMyTrips, useSvcMutation } from '../api/services';
import { formatHotelTime } from '../format';
import { Badge, Button, Empty, ErrorNote, Loading, useReport, useToast } from '../ui/kit';
import { PageHead } from './shared';

/** A driver's own list: where, when, who, and one big button for the next step. Money is not shown. */
export function DriverTrips() {
  const { me } = useAuth();
  const trips = useMyTrips();
  const toast = useToast();
  const report = useReport();
  const go = useSvcMutation((v: { id: string; path: 'start' | 'finish' }) => api(`/transport/my-trips/${v.id}/${v.path}`, { method: 'POST', body: {} }));
  const tz = me?.property.timezone ?? 'Africa/Accra';

  return (
    <div className="page">
      <PageHead eyebrow="Driver" title="My trips" />
      {trips.isLoading ? (
        <Loading rows={2} />
      ) : trips.error ? (
        <ErrorNote error={trips.error} retry={() => void trips.refetch()} />
      ) : (trips.data ?? []).length === 0 ? (
        <div className="card flat">
          <Empty icon="check" title="No trips for you right now">New trips appear here when the front desk assigns them. This list updates by itself.</Empty>
        </div>
      ) : (
        <div className="stack">
          {trips.data!.map((t) => (
            <article key={t.id} className="card">
              <div className="card-head">
                <h2 className="h2">{formatHotelTime(t.pickupAt, tz)}</h2>
                <Badge tone={t.status === 'DISPATCHED' ? 'brand' : t.status === 'COMPLETED' ? 'good' : 'info'}>{t.status === 'DISPATCHED' ? 'On the road' : t.status === 'COMPLETED' ? 'Done' : 'Ready'}</Badge>
              </div>
              <dl className="kv">
                <dt>Pick up</dt>
                <dd>{t.pickup}</dd>
                <dt>Take to</dt>
                <dd>{t.dropoff}</dd>
                <dt>Passenger</dt>
                <dd>
                  {t.customerName} · {t.passengers}
                  {t.phone ? (
                    <>
                      {' '}
                      · <a href={`tel:${t.phone}`}>Call {t.phone}</a>
                    </>
                  ) : null}
                </dd>
                <dt>Vehicle</dt>
                <dd>{t.vehicle?.name ?? 'Not assigned'}</dd>
              </dl>
              {t.notes ? <p className="small muted">{t.notes}</p> : null}
              {t.status === 'CONFIRMED' ? (
                <Button variant="primary" block loading={go.isPending} onClick={() => go.mutate({ id: t.id, path: 'start' }, { onError: report, onSuccess: () => toast.ok('Safe trip! Marked as started.') })}>
                  Start trip
                </Button>
              ) : null}
              {t.status === 'DISPATCHED' ? (
                <Button variant="primary" block loading={go.isPending} onClick={() => go.mutate({ id: t.id, path: 'finish' }, { onError: report, onSuccess: () => toast.ok('Trip finished. Thank you.') })}>
                  Finish trip
                </Button>
              ) : null}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
